export { LockBadge } from './LockBadge';